import { Component, Inject } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PershingTranslationService } from '@pershing/pershing-core';

@Component({
  selector: 'trade-restrictions-popup',
  templateUrl: './trade-restrictions-popup.component.html'
})

export class TradeRestrictonsPopupComponent {

  tradeRestrictions = [];
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private dialog: MatDialog,
              private translationService: PershingTranslationService) {
    this.tradeRestrictions = data.datakey1;
    this.translationService.addTranslationFolder('@pershing/nxi-ng-portfolio', 'node_modules/@pershing/nxi-ng-portfolio/lib');
  }

  closeDialog() {
    this.dialog.closeAll();
  }
}
